module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapnum"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle"
  }, [_vm._v("Ordered to Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("I")]), _vm._v(" have been induced, at this distant period, to record transactions, which, however interesting at the time of their occurrence, or rotted long afterwards in the memory, have now, for a considerable time, been fading. My written journal has been lost; and pursuits, of a nature scarcely compatible with vivid recollections, have contributed, perhaps too successfully, to eradicate impressions, which I first received about fourteen, and was removed from nearly twelve years ago. Nevertheless, as I have the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("misfortune")]), _vm._v(" to be the keeper of a memory that rarely forgets anything, I will not affect to be unable, even at this distance of time, to reduce to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("paragraphs")]), _vm._v(" some of those reminiscences which have casually interested the social circle, and have, even to the surprise of the narrator, created a sensation, in which he himself barely participated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The private history of important transactions, as well as of conspicuous personages, is always amusing and sometimes instructive. The economy of military men, when actively engaged, on occasions of deep interest, will always be productive of matter, attractive to those who sit at home and who learn but confused accounts of what may be going on. Things perfectly familiar to us, I have found incomprehensible to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("others")]), _vm._v("; and I confess to have been amused with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("naivete")]), _vm._v(" of queries put to soldiers by intelligent men, who never saw any military "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("apparel")]), _vm._v(" beyond a review at Hounslow."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn1",
      "id": "ch1fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" There is occasionally an awfulness, but more frequently an apparent insignificance, attached to the proceedings of a large army on active service, which are, both of them, highly interesting. I will not say, that when a Yorkshire man is placed in a hussar saddle, reduced to the clothes on his back and the provender slung over his shoulder, with the prospect of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cutting six")]), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn2",
      "id": "ch1fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" at a native of Orleans [France], in ten minutes, that "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("he is exactly the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("character")]), _vm._v(" he would be upon the Doncaster racecourse;"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn3",
      "id": "ch1fn3"
    }
  }, [_vm._v("3")])]), _vm._v(" but I am sure he is the same "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("person")]), _vm._v(". For my own part, on some of the occasions I am about to describe, I should have thought any hovel in England enviable quarters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reader will not however, thank me for prolonging these preliminary observations. Passing over, therefore, for the present, several years, (during which I had been engaged, with as much advantage to myself as to the public service, in a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("medical")]), _vm._v(" capacity in the peninsula"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn4",
      "id": "ch1fn4"
    }
  }, [_vm._v("4")])]), _vm._v("), I shall introduce my narrative, as commencing with the early part of the eventful year, 1815. Many will recollect how the metropolis was at that period, the scene of popular tumult, on the occasion of certain measures projected by government, with regard to the regulation of the corn market. The present Lord Goderich,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn5",
      "id": "ch1fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" (then President of the Board of Trade) attracted a considerable share of odium; and his proceedings were not only censured by the nobility of London but animadverted upon by those who were at too great a distance for their execrations to reach his ear, or their stones to break his windows. On a dead wall, adjoining the capital of Berkshire,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn6",
      "id": "ch1fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" I was amused with an inscription "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a la Hunt")]), _vm._v(", which pointed out the propriety of ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Robinson’s ribs forming a gridiron to broil Castlereagh’s heart on.")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To this town and neighbourhood, my regiment (a cavalry one"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn7",
      "id": "ch1fn7"
    }
  }, [_vm._v("7")])]), _vm._v(") was, in consequence of these riots, ordered, by forced marches, to repair; and we remained there, in hourly expectation of proceeding to London."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn8",
      "id": "ch1fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" The Oxford Blues"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn9",
      "id": "ch1fn9"
    }
  }, [_vm._v("9")])]), _vm._v(" had left their usual and enviable quarters, for the duty (of "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("all others most unpleasant to English soldiers) of laying the strong hand upon their fellow citizens. John Bull had at the period in question, a very erroneous opinion of the character and feelings of his defenders. It was too much the custom even then for ignorant persons to abuse and for the intelligent to dislike them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While anticipating the highly repugnant order to approach the turbulent metropolis, the newspapers one morning announced that Bonaparte had escaped from Elba! For a single day, we ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("militaries")]), _vm._v(") were in common with the rest of our countrymen, abandoned to every degree of wonder and astonishment at this unexpected event. I recollect that the squadron-mess, to which I at that time belonged, met as usual in the principal inn of the town,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn10",
      "id": "ch1fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" and talked this exploit over with as much indifference as might have been due to the escape of Sir F[rancis] Burdett from the Tower, or of Lord Cochrane from the King’s Bench."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn11",
      "id": "ch1fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" Next morning, however, things assumed a different aspect "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quoad nos")]), _vm._v(" [with regard to us]. Something like a warning for foreign service reached us and we learnt that the colonel,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn12",
      "id": "ch1fn12"
    }
  }, [_vm._v("12")])]), _vm._v(" ‘A warrior (as will in due time be seen) for the working day’, had arrived at headquarters. To me, who at that time knew this honourable and gallant character more by report than personal observation, such an event appeared to be in the ordinary course of affairs. I was, however, somewhat mistaken: for afterwards I knew my chief too well, to suppose that he would care about making himself visible when nothing was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("to be done")]), _vm._v(". He arrived, however, and some of our outpost associates went to pay their duty to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Saturday, 19 March (I think"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn13",
      "id": "ch1fn13"
    }
  }, [_vm._v("13")])]), _vm._v(") 1815, our detachment proceeded, not to quell a London mob (as the unexpected "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("retour de L’Empereur")]), _vm._v(" [return of the Emperor] had done more for that purpose than the appearance of "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("the whole British army would perhaps have accomplished), but to embark for Belgium. Our march, which in its rapidity, seemed to betoken the spirit of the emergency, furnishes few incidents worthy of record. But as I do not pretend to quote adventures, my recollections being confined to the everyday and hourly occurrences of the interior of military life perhaps I may find readers if I indulge in a few descriptions of a comparatively humble nature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our first halt was at the miserable but well-known town of Hounslow,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn14",
      "id": "ch1fn14"
    }
  }, [_vm._v("14")])]), _vm._v(" where our temporary commanding officer"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn15",
      "id": "ch1fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" exhibited so little tact as to higgle ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sic")]), _vm._v("] about sixpence per head in the dinner charge the effects of which were rather severely visited upon the party. He was laughed at by the subalterns who witnessed the bargain but consoled himself with the idea that they were but ‘boys’, who little knew the care he was taking of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before we assembled at the headquarters inn, Lieutenant [Goldsmid]"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn16",
      "id": "ch1fn16"
    }
  }, [_vm._v("16")])]), _vm._v(" and I took a stroll in Osterley Park,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn17",
      "id": "ch1fn17"
    }
  }, [_vm._v("17")])]), _vm._v(" and round the skirts of the town, in the course of which he led me to a spot whence several roads branched off, and there demonstrated the manner in which he had brought a London tailor to terms upon a former occasion. As well as I can recall the story, it was to the following purport:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the arrival of the regiment, the year before, from the continent, one of the first places in which they became objects of notice to the London tradesmen was this same town of Hounslow. There, many of the officers appointed tailors, bootmakers, saddlers and others of that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genus,")]), _vm._v(" to come to them, in order to clear off old scores and to commence new."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn18",
      "id": "ch1fn18"
    }
  }, [_vm._v("18")])]), _vm._v(" Among the good customers was a Captain C[oles],"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn19",
      "id": "ch1fn19"
    }
  }, [_vm._v("19")])]), _vm._v(" but my present companion, the lieutenant, happened to have gone through the peninsular campaigns, without the cordial consent of some of the above-mentioned tribe. In the very same inn, where, on the present occasion, we had bargained for "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("a cheap dinner, the greedy tradesmen met their customers, and among them was a celebrated West-End tailor, who had no great regard for my friend the lieutenant, having (as he, the said tailor alleged) been rather cavalierly treated by him on former occasions. Our officer (whom, for brevity’s sake, I shall call G[oldsmid]) happened to enter Captain C[ole]’s apartment and was by the latter informed that such and such a tailor had been there, and would return within a certain time, so that if G[oldsmid] wanted anything, he could take the opportunity to give his orders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The effect of this information was an immediate exit through a window (the room being on the ground floor) which gave issue to the stable-yard, the saddling of his horse and a message for Dick E[Fulton"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn20",
      "id": "ch1fn20"
    }
  }, [_vm._v("20")])]), _vm._v("], a brother officer, to repair forthwith to Hounslow Heath where he would learn something of great importance. Out sallied my friend to a spot, where, with no little exultation, he informed me there was a clear start into four different counties and where he would have the tailor at his mercy, inasmuch as he could not have taken out a writ in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("more than two")]), _vm._v(". Dick did not fail in the appointment. The lieutenant offered terms, Dick explained to the tailor how matters were, how G[oldsmid] was already "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a cheval")]), _vm._v(" on the heath and prepared for flight in any direction whatever. A promissory note was gladly accepted, the writ cancelled and the lieutenant marched into the west of England"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn21",
      "id": "ch1fn21"
    }
  }, [_vm._v("21")])]), _vm._v(" with all the honours of peace, as well as of war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now to our dinner. I forget what we had to eat; but whatever it was, I am not inclined to think that we got much harm by it. The bargain about the sixpence secured us against any hazardous luxuries of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cuisine,")]), _vm._v(" and not only so, but ensured us the very worst bottle of wine mine host could find in his cellar. This we had sense enough to discover on tasting the first glass and we decidedly objected to proceeding one drop farther. The lieutenant ordered a change; we only changed from bad to worse. A second change was insisted upon and we had absolutely got in the landlord, blown him up and agreed to give eight shillings a bottle (for port!) before we should be fairly sacrificed to the honour of "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("the odd sixpence. For my own part, finding the wine unswallowable, I retreated at an early hour, but others of the party remained, in the sure and certain hope of bettering their condition, by raising the price of their indulgence. Next morning some were left seriously ill in bed and the exhibition made by others told very expressively, what may be done by the saving of sixpences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our route lay across Kew Bridge; and just at the east end of Brentford, we met a gentleman driving a curricle,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn22",
      "id": "ch1fn22"
    }
  }, [_vm._v("22")])]), _vm._v(" to which was harnessed a pair of rather spirited horses."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn23",
      "id": "ch1fn23"
    }
  }, [_vm._v("23")])]), _vm._v(" The animals were not a little agitated at the sight and clatter of the cavalry, and there would have been "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a charge")]), _vm._v(", without doubt, had not the driver reined up to let us pass. Our commandant, who was remarkably near sighted, was on the point of giving the gentleman some very unceremonious advice, when we had the good fortune to recognise his late Royal Highness the Duke of Kent."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn24",
      "id": "ch1fn24"
    }
  }, [_vm._v("24")])]), _vm._v(" The only subaltern who had been able to march with us, was immediately ordered to the rear, to ascertain that the troops were in a proper state of regularity, before the Royal Duke should have an opportunity of seeing them. In doing so, the wine that had been forced down his throat the evening before, began to take effect, just as the Royal Field Marshal had an opportunity of witnessing it. Whether he saw the accident or not, we never heard. The young gentleman is now a field officer, and a great ornament to his majesty’s service.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On we went for Bromley, which was to be our resting place for the night; but, somewhere about Clapham Common, we lost our way and what was rather singular, could find no one capable of directing us."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn25",
      "id": "ch1fn25"
    }
  }, [_vm._v("25")])]), _vm._v(" At length we trotted past Deptford, in which neighbourhood was residing a young lady, to whom at the time, I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("believed myself")]), _vm._v(" to be very much attached and for whom I absolutely had at the moment a poetical epistle in my valise. When I set out in the morning, I did not know which way we were to go and it was not till we arrived near the place "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("that the notion of an interview occurred to me. I now, however, stated to the commanding officer (the saver of sixpences) that, as I was passing very near the residence of a particular friend, I wished to take leave. G[oldsmid] desired me to take what I liked, provided I took myself to Bromley by dinnertime. So I cantered off to beat up Miss [?]’s"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn26",
      "id": "ch1fn26"
    }
  }, [_vm._v("26")])]), _vm._v(" quarters. ‘Gone to church!’ was the answer, (it was Sunday morning). I put up my charger and in the conspicuous uniform (a thing the damsel held to be an abomination) of the dragoons, paraded up and down till I had an opportunity of astonishing her with my appearance, ‘Is it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("possible")]), _vm._v("? What brought "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" here?’ were the enquiries. ‘A tolerably good horse’, was the reply. ‘Where are you going?’, ‘I really do not know, but I believe "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("abroad.")]), _vm._v(" I have brought a letter for you, which I thought I might as well take the opportunity of delivering in person, as it may be some time before another occurs.’ So we kept walking about and talking for an hour, at the end of which I was obliged to take my leave and I am very sure my fair friend was glad of my departure. She had been brought up with an unlucky idea; too prevalent at the time, that no man could be good for much who wore the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("King’s livery")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Bromley nothing remarkable occurred. I forget what sort of a dinner we had, but I remember that our little party was exceedingly merry. We were waited upon, not by a gentleman dressed like a professor in the University of London, but by ‘neat-handed Phillises’,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn27",
      "id": "ch1fn27"
    }
  }, [_vm._v("27")])]), _vm._v(" with whose general aspect and deportment we were much pleased. Coming off a duty march, we were not much inclined to dress for the ceremony; yet, as some alteration of garb is always attended to when practicable, we agreed not to change, but to turn our jackets inside out. When we met after this little metamorphosis, our appearance was so irresistibly droll, both in the eyes of ourselves and the handmaids, that we could hardly eat our meal on account of the incessant laughter proceeding from both parties. Calling the guests to order, reprimanding the servants (in the way in which both were attempted) only added to the hilarity. After dinner, the senior officer came from another inn, where he was billeted, to take his wine with us. Not being at all in the secret of our innovations upon the article of dress, his astonishment was so genuine and its expression "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("so unaffectedly ludicrous, that one of the damsels absolutely lost her senses and went into fits of really convulsive laughter! In which we the more effectively joined as we had anticipated the surprise and our sides were stronger and fitter for the task than those of the poor females. Of course, we did not exhibit out of doors in this costume; nor had we any desire to leave a scene so merry as the interior of the house. The whole establishment planted themselves wherever they could, to get a peep at the gay fellows going to fight Bonaparte and wherever we moved there was a head to be seen, or a giggle to be heard. We went to our rooms amid roars of laughter at night; and when we came down next morning, with things on as they should be, the recollection of the preceding day was still too much for decorum. We left the town of Bromley, perhaps the merriest party that ever entered it; and though within three months, the head of one of these cheerful individuals was laid low among the heroes of Waterloo, I am now (at the distance of fourteen years) almost unable to record the incident, in itself perhaps trifling enough, with any sort of gravity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our next halting-place was Rochester; where we arrived on the day appointed for the launch of a line-of-battleship from Chatham; if I remember rightly, she was ‘the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Howe")]), _vm._v(".’"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn28",
      "id": "ch1fn28"
    }
  }, [_vm._v("28")])]), _vm._v(" It was a sort of coincidence that the first of the troops, ordered to meet the disturber of the peace of Christendom, should have come to the place where a specimen of Britain’s other force was to be exhibited, in a situation of efficiency, for the first time. I shall quote in the sequel; but I am the less disposed to omit this one, as our halt in Rochester produced nothing worthy of notice. We were billeted in different inns and on the following morning, I had the bad luck to pry into a little bit of scandal, in the most innocent and unintentional manner conceivable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of my brother officers had sneaked off from the mess at an unreasonably early hour the evening before, upon some frivolous pretext of duty or fatigue, which we had been rather the less inclined to question, as he was a married man, whose wife was somewhere on the line of march. At all events, we did the best we could without him and sought our own repose at the usual time. Before we moved off next day, I strolled to the inn where this gentleman was quartered, dressed precisely as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("was, though in person we were not much alike. I was standing in the gateway, with my face to the street, when a gentle tap was given to my shoulder and a soft voice uttered, ‘I say!’ This brought me round and oh! imagine if possible, with what expression of countenance the exclamation was made, ‘Good gracious! I beg your pardon Sir, it isn’t you.’ [I replied] ‘Yes, but it is though, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("myself")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nobody else")]), _vm._v(".’ I now complimented her (a not a very handsome, but rather a neat-looking chambermaid) gave her a wink of re-assurance and said that I would send the gentleman to her. I found him just about to mount his horse and told him that the chambermaid had given me a message for him. ‘The devil she has! What is it?’ [I replied] ‘You shall hear as we ride on; but I think you ought to take leave.’ ‘Well, if you will ride with me, I will explain it all!’ [to which he replied] ‘My dear fellow, there is no occasion whatever; it is all explained already. You have the greatest knack,’ he replied, ‘at finding out every body’s business of anyone I ever met with.’ ‘Well, but I don’t think Mrs H[eydon]"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn29",
      "id": "ch1fn29"
    }
  }, [_vm._v("29")])]), _vm._v(" will call this your business when she comes to hear of it; and you know where are no secrets in regiments.’ We did ride together, all the way to Sittingbourne; in the course of which, I was duly informed of the particulars and promised not to tell the wife. All that I can say of Sittingbourne is that we entered it on a Tuesday, found all sorts and descriptions of artillery pouring into it, and left it on Wednesday morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was my first visit to the count of Kent, the kitchen garden, (as Surrey may be called the pleasure ground) of England.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From Sittingbourne we proceeded to Canterbury, a city which I approached with all the feelings and anticipations of a young man romantically inclined and habituated to look upon the relics of antiquity with something like poetic interest. Our party marched in upon the Wednesday; but the whole regiment (as it had proceeded in separate detachments) did not assemble there till Friday. Of the beauties of the ecclesiastical metropolis, however, I am not going to say a word: there are printed guides for visitors and I must confess that, under the circumstances in which I was placed, I either acquired very imperfect notions of the city and its curiosities, or other matters have since driven them from my "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("recollection. I did not pass the three days alluded to in much of a poetical manner; so that it will be better for all parties if I proceed to discuss matters "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a la militaire.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Friday, about noon, the last detachment marched in; and the whole regiment was assembled in a field near the barracks,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn30",
      "id": "ch1fn30"
    }
  }, [_vm._v("30")])]), _vm._v(" for an operation of a very important and interesting nature; in order to do justice to any allusion to which, it is necessary that I introduce a digression.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our corps was the first, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("of any description")]), _vm._v(", which, (on the news of Bonaparte’s re-appearance in France) had been ordered for foreign service. It had returned from the Peninsula but a few months previously and was found, as soon as an inspection was made,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn31",
      "id": "ch1fn31"
    }
  }, [_vm._v("31")])]), _vm._v(" to be ready for active duty in any part of the world and we were the second corps that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("actually got")]), _vm._v(" to the continent, one other regiment having been upon the coast and ready to embark, when the mandate was received. When we reached Canterbury, we found a third cavalry regiment under similar orders; but we left them there, and several weeks elapsed before we had the pleasure of seeing them on the other side; and I recollect hearing that they had required all this period to accomplish what the [12th Light] Dragoons did in one afternoon. And what was this? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Re-Trooping")]), _vm._v(" the regiment; a ceremonial which, for the benefit of country gentlemen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yeomanry")]), _vm._v(" and others, I shall endeavour to explain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On foreign [home] service, a regiment of cavalry consists of ten troops, composed of about seventy mounted men and ten or fifteen dismounted, to supply casualties, furnish servants, &c &c. The whole are seldom if indeed ever sent abroad: two at least and sometimes even four, remaining at home, to form the depot, or source of supply both of men and horses, which the wear and tear of service may demand."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn32",
      "id": "ch1fn32"
    }
  }, [_vm._v("32")])]), _vm._v(" During the time of peace, the troops are reduced, both in number and strength, (there being no regiment of dragoons at present in England consisting of more than six troops and these not exceeding forty horses each). When our regiment was placed upon the peace establishment in 1814, it had been reduced to eight troops, which formed the strength of it at the time now referred to; but from these eight,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn33",
      "id": "ch1fn33"
    }
  }, [_vm._v("33")])]), _vm._v(" six were to be selected, composed of "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("the most effective soldiers; and those six were to consist of seventy horses and eighty-five men each. In order to make this new arrangement, every man was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("untrooped")]), _vm._v(","), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn34",
      "id": "ch1fn34"
    }
  }, [_vm._v("34")])]), _vm._v(" personally inspected by the medical officers and replaced in some one particular troop, there to have his ‘local habitation and his name’, during the active period before him. A similar ordeal was instituted with respect to the horses and what may create surprise, there was a selection of women! The regiment had a proportion of wives, which amounted to a great inconvenience and four only per troop were permitted to accompany their husbands and to become, in consequence, entitled to rations and quarters. Some female followers are indispensably necessary, for purposes of washing and other services which cannot be conveniently obtained in foreign countries, more particularly when the army is in motion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now all this work, under the eye of one of the best officers to whom King George ever confided the command of his soldiers, was accomplished by six o’clock on Friday evening. At seven on the morning of the following day, the six newly arranged troops, forming three fine effective squadrons, proceeded to Ramsgate, where the whole concern, animate and inanimate; right, centre and left; horse, foot and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dragoons")]), _vm._v(","), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn35",
      "id": "ch1fn35"
    }
  }, [_vm._v("35")])]), _vm._v(" were put on board the transports, in which they sailed, with a fair wind, to Ostend at an early hour on the morning of Sunday, April 1 [2nd].")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I must return to Canterbury, in order to account for my embarkation at Ramsgate; a little paradox, which I hope the reader will not only forgive, but feel somewhat amused with the explanation of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As far as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("medical")]), _vm._v(" duties of the trooping business were concerned, they had been performed by the surgeon"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn36",
      "id": "ch1fn36"
    }
  }, [_vm._v("36")])]), _vm._v(" and myself, the other (senior) "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("assistant,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn37",
      "id": "ch1fn37"
    }
  }, [_vm._v("37")])]), _vm._v(" of whom I shall have at least enough to say in the sequel, having taken himself off to London, when we moved from Berks[hire] and having never been seen or heard of since. What he found to do in London, no one could possibly imagine, as he had neither friends nor business there of any known description. We were not sorry for his absence, on the occasion in question, for Larry Murphy [Patrick Egan] had ways of performing, or of spoiling duty, altogether on his own and utterly at variance with those of every other person, civil or military. The only cause for vexation to myself was that, when the order arrived to proceed on foreign service, he had claimed the right of accompanying the regiment, as the opportunity was one which would secure his promotion, whereas by staying with the depot, (as either he or I was to do) he ran the risk of being passed over. As he was some two [one] years my senior, any attempt to overturn this arrangement would have been unreasonable, as well as fruitless. My worthy and kind friend, the surgeon, comforted me with the assurance that, from what he knew of Murphy [Egan], as well as from the opinion generally entertained about his value, there was every chance of his being left behind and that I had better make my arrangements for going. We were aware that Larry [Patrick] had not a horse, having sold his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("charger")]), _vm._v(" (a half-starved pony) the day before we left our quarters in the west of England. This might appear to be a very common-place event; but my brother chip [surgeon] forgot, when he put the animal up to auction on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saturday")]), _vm._v(", that we had received the order to proceed towards London, by long and forced marches, on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monday")]), _vm._v(". The pony was no sooner knocked down, however, than he recollected this and exclaimed, even in the marketplace, ‘Och, what will I do for a horse?’ The beast fetched seven pounds nineteen shillings"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn38",
      "id": "ch1fn38"
    }
  }, [_vm._v("38")])]), _vm._v(" and the purchaser, understanding the state of the case, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kindly")]), _vm._v(" offered to let the recent owner have it again for about double the money; but Larry [Patrick] was perfectly frantic at so barefaced an imposition and swore he would rather walk all the way than be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chated")]), _vm._v(" in such a manner. I believe he did ride a spare trooper and, as he wore no uniform and was never out of bed in time to proceed with the squadron, he had to raise an argument at every "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("too-bar")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("[toll booth] about passing without payment. Sometimes he was obliged to wait till a straggling soldier, or the baggage came up, in order to obtain a voucher that he was an officer of the regiment gone forward; at other places he was let through as an officer’s servant, which the tollkeepers occasionally took the liberty of saying he resembled much more than an officer. At one gate, he recognised in the keeper an old soldier who had experienced his tender mercies in the peninsula."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn39",
      "id": "ch1fn39"
    }
  }, [_vm._v("39")])]), _vm._v(" The man totally unprepared for another visit from his doctor, wanted to be paid; ‘What! You ungrateful scoundrel, do you pretend you don’t know me? Have you forgot how I saved your life at Talavera?’ ‘Oh, Sir!’ was the reply, ‘go through and welcome, I did not look at you, or I should have recollected your extraordinary countenance at once: nobody can ever forget it, who has once seen it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Up to six o’clock on the Friday evening I remained in a disagreeable state of suspense as to the manner in which I was to be disposed of. My family as yet knew nothing of my movements. At this time, having ‘borne the burden and heat of the day’, I accosted the major as follows: ‘Major, I am in a very unpleasant situation. Murphy [Egan] has not yet made his appearance and I understand he claims the right of accompanying the regiment. I have not had much personal acquaintance with the colonel and I do not like to thrust myself on his notice at this busy moment. Will you have the kindness to ascertain whether I am to go or stay, for my baggage is yet unselected and I have some arrangements of considerable importance to my comfort to make.’ The good and gallant man replied: ‘Why, is it possible you don’t know? You are to go, whether Murphy [Egan] comes in time or not, Colonel [Ponsonby] has had his eye upon you all day and has decided the matter in the proper way, so make your arrangements for marching with us tomorrow.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The words were scarcely out of his mouth, when all that was useless and provoking appeared in the shape of Larry Murphy [Patrick Egan] himself! He came, just in time, (off the top of a London coach, covered with dust and dressed in a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shabby genteel")]), _vm._v(" sort of barber’s clerk uniform of sky-blue) to catch Colonel [Ponsonby] as he was mounting his horse, to leave the busy scene of our somewhat tiresome operations. I said to him, ‘Murphy [Egan], you are too late, you are to be left behind with the depot. It is all settled and I must go with the regiment.’ ‘Jesus,’ said the selfish "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("creature, ‘this will be the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ruin")]), _vm._v(" of me.’ ‘Well,’ I replied, ‘you should have been here to look after your own interest, however, there is the colonel; you had better speak to him; don’t take my word for it.’ He approached our chief, who had the good nature to listen to his lame story and being one of those generous characters who never could pronounce the word ‘No’ he got out of the dilemma, by saying he had left the decision of the question to the surgeon, referring Mr Murphy [Egan] to him accordingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry [Patrick] then returned to me and said, ‘I don’t care about going,’ (indeed, I saw he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("could not")]), _vm._v(" go, for he was totally unequipped and dismounted into the bargain) ‘but as I know S [Robinson]’ (the surgeon) ‘would put a spoke in my wheel if he could, I want to see him, as Colonel Ponsonby has referred me to him and hear what he has to say. Where are his quarters?’ I directed him accurately and was leaving the barrack-yard (where this scene had taken place) to mind my own business, when he came back, saying he could never find his way to [Robinson]’s without my assistance and desiring that I should go with him. Almost fainting with fatigue (rather of mind however, than of body) and much in want of my dinner, I undertook to show him the way; but to my dying hour, I shall not forget the colloquy which the visit occasioned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We found [Robinson] at high dinner, up one pair of stairs, at the top of which he made his appearance, with a knife in one hand, a fork in the other and his mouth crammed with beefsteaks, or something else, intended to go further into his interior than the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Murphy")]), _vm._v(" [Egan] which held me by the arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, Sir!’ exclaimed [Robinson], ‘you are come at last.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘To be sure I am.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And why did you not make your appearance before? J[ohn] and I have had to perform the heavy duty of inspecting every man in the regiment, while you have been amusing yourself in London. Pray, Sir, what do you want with me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, I want to know whether J[ohn] or I shall go with the regiment, because the colonel say it is left to you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why then, if it is left to me, I have to say that I consider you have forfeited all right to go and in my opinion, you are not able to go.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not able!! Not able!! what do you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mane")]), _vm._v("? I’m as able as ever I was in my life and I will go!’")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very well, Mr Murphy [Egan], as you are so determined about it, I have little more to say, only I must put one or two questions to you. Have you got a horse? have you a kit? are you effective?’"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn40",
      "id": "ch1fn40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sure, I always had a horse.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, till you sold him, but have you one "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("now")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sure, I can get one in five minutes and I always had a kit.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well Sir, as I know that you have no horse, no regimentals, no equipment of any kind and now know nothing of the actual state of the regiment, which J[ohn] and I have taken "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" share of duty in ascertaining, you must remain here and J[ohn] will go with us?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very well! Mighty fine! All I wanted was to know that you preferred J[ohn] to me. Good morning to you and the divil go "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wid")]), _vm._v(" you!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nay,’ said [Robinson], ‘I do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" prefer J[ohn] to you, one officer if effective is as good as another; but you are notoriously not effective. J[ohn] I know, has a perfect equipment for foreign service; he has purchased a second horse this afternoon and the commanding office has selected him for the duty before us. You will attend tomorrow at eight o’clock, to take over the charge of the depot hospital and J[ohn] will march with the troops.’")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I cannot exhibit the actors upon this occasion in the reality of their performance. For my own part, I could hardly contain my gravity at the mock heroic of [Robinson], as contrasted with the petulance of Murphy. We were not even asked upstairs, (for which I could well account); but Murphy [Egan] turned from the inhospitable door with a thousand Irish exclamations, as to the indignity of his treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My dear fellow,’ said he, as we walked down the street, ‘I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("knew")]), _vm._v(" I could not go, I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("can’t")]), _vm._v(" go, I don’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("want")]), _vm._v(" to go, you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ought")]), _vm._v(" to go. I am glad you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" going; but [Robinson] is no friend of mine and all I wanted was a row about it. As you are to be off tomorrow, I hope you will write me an account of proceedings.’ Whether I gave Larry [Patrick] any promise to this effect, I have now forgotten; but I know that I was very glad to get rid of him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I saw nothing of him on the ensuing morning; but instead of being at his post by eight o’clock, I learnt afterwards, that three messages, the last not the most courteous, had been delivered to him by as many non-commissioned officers, before he could make up his mind to leave his couch for the purpose of attending at the hospital. In the course of the day S [Robinson] joined us at Ramsgate; and having seen our nags safely paraded in the hold of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the largest and finest transport")]), _vm._v(" we could select from the fleet, as head-quarter ship, Joe B [James Castley] (the Veterinary surgeon),"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn41",
      "id": "ch1fn41"
    }
  }, [_vm._v("41")])]), _vm._v(" S [Robinson], and myself spent the day together on shore, all of us, with the addition of the Paymaster"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn42",
      "id": "ch1fn42"
    }
  }, [_vm._v("42")])]), _vm._v(" and Adjutant,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn43",
      "id": "ch1fn43"
    }
  }, [_vm._v("43")])]), _vm._v(" repairing on board the ship to sleep, as we were to sail at a very early hour next morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither the colonel nor the major embarked with us, though (as will be shewn in the sequel) they were ready to receive us on our arrival at the other side. The presence of neither would have laid us under any unpleasant restraint; but we fared all the better for their absence, in the article of accommodation, which in the event, became of more importance than could have been calculated upon at setting out. Had we been bound for any distant place, or likely to be long at sea, two medical officers would not have been allowed to proceed in the same ship; but we anticipated a short run across and the vessel was appropriated to the regimental staff "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("generally, commissioned and non-commissioned. We arrived at rather a late hour, on board the transport, on Saturday night, March 31 [1 April]; and scarcely had we descended the companion ladder, when great offence was taken at the master. The fact was, that the rude fellow, having been pretty well insulted in his time, had thought proper to get drunk in the most independent and then "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("to turn in")]), _vm._v(", in the most indifferent manner, leaving word, that he would be dammed if he would keep watch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("to please all the officers of the army")]), _vm._v(". This "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("calm")]), _vm._v(" determination was the more formidable, as the steward had absconded and not one among us knew where to get bed or blanket, or even where to place them if we had them, nobody having acted quartermaster, in making a previous "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("reconnaissance")]), _vm._v(" of the ship. Something however, was essential and remonstrances were forwarded to the captain, first of a gentle, but at last of rather a peremptory nature, which procured us the bedding; and we then arranged ourselves in berths, starboard and larboard,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn44",
      "id": "ch1fn44"
    }
  }, [_vm._v("44")])]), _vm._v(" the surgeon claiming (as senior) the state-room, left empty by the absence of the commanding officer. For my own part, I would not have exchanged my open berth in the cabin for all his luxury and dignity and we of the πολλοί,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn45",
      "id": "ch1fn45"
    }
  }, [_vm._v("45")])]), _vm._v(" enjoyed a midnight laugh there, at his expense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although I have said that the Paymaster was of the embarking party, he did not make his appearance till after we had all gone to roost. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Growler")]), _vm._v(" [Otway] (as he was nick-named) entered the cabin about twelve o’clock, none the better seaman for the wine he had taken on board. He was, upon most occasions, an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("intolerably")]), _vm._v(" haughty fellow and had the art of expressing himself as if he had been Brian Borou [Boru],"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn46",
      "id": "ch1fn46"
    }
  }, [_vm._v("46")])]), _vm._v(" instead of a Regimental Paymaster. Upon the occasion in question, he was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("enormously")]), _vm._v(" high; and filled with ideas of his own dignity and delicacy, was perfectly frantic at finding, in the berth allotted to him, the full flood of an urn sacred to Bohea,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn47",
      "id": "ch1fn47"
    }
  }, [_vm._v("47")])]), _vm._v(" confined however, in a stagnant state, within its brittle banks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Steward!’ No answer. ‘I say, you dammed steward!’ Silence still.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s the matter, Growler [Otway]?’ says B[Castley].")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why by Jingo, they’ve put a slop basin full into my bed, on purpose to insult me. Steward!’ Still midnight silence.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I have never heard of such insolence’, said the occupier of the state-room [Robinson]; ‘let us have the master in directly; as senior officer, I will take the affair upon myself.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After considerable delay, during which Growler [Otway] sat, with the piece of tea furniture in his hand, upon a camp stool, the master did make his appearance for the first time, not in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("full dress")]), _vm._v(", but drunk, wroth and eloquently impertinent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What do you want?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The dammed lazy steward to empty this slop.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ve got no steward; he ran away yesterday.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then, Sir, as you do not keep a steward, take it directly and empty it yourself.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Empty it myself! I’ll see you all dammed first. Where are your servants?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What? Do you suppose our servants have nothing else to do but clear the leavings out of your ship?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, if you don’t chuse to employ your servants, you can clear them away yourself, it’s no business of mine.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("S [Robinson], who had heard the whole colloquy (without interfering), now raised an authoritative voice and exclaimed, ‘You, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sir")]), _vm._v("! How dare you insult officers of the King’s cavalry? You are bound to receive us into a clean ship; but this is no better than a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dung")]), _vm._v(" barge.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why’ replied the pot-valiant captain, ‘I don’t think she is much better when she carries such cargoes as you!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here the general laugh became so ungovernable, that silence ensued among the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("linguagerent")]), _vm._v(" ["), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sic")]), _vm._v(" – belligerent?] parties.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were alive betimes on the following morning; for the event of sailing at a very early hour was one we hardly could be expected to oversleep."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn48",
      "id": "ch1fn48"
    }
  }, [_vm._v("48")])]), _vm._v(" Before we went on deck, we called a council of war upon the occurrences of the previous night and unanimously agreed, that ‘the captain of the barge’ was an impertinent scoundrel, with whom no measures of civility could possibly be observed during the remainder of our abode under his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("deck")]), _vm._v(". With this prejudice we mounted the aforesaid deck, the theatre of our intended scorn, where we discovered our foe busily employed in "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("making the necessary arrangements for our departure, with which he appeared to mingle no ordinary solicitude for the accommodation of the dragoons and (what at the moment rather vexed than pleased us, such was our dislike of him) great anxiety about the welfare of our "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("horses")]), _vm._v(". It was touching cavalry men in the tenderest point. If he wished to make the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("amende")]), _vm._v(" [apology], a volume of supplicatory letters would not have had the effect of his simple order to ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see if the gentlemen’s horses were properly stowed; and to mind that the water and windsails were quite handy!")]), _vm._v("’"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn49",
      "id": "ch1fn49"
    }
  }, [_vm._v("49")])]), _vm._v(" This altered the case materially, as to matter of opinion; but the difficulty was yet to be got over concerning who should speak first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To the honour of the service, I have to record, that the first overture of this nature emanated from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ourselves")]), _vm._v(". I was sent to the captain and in sufficiently civil, though probably not very condescending terms, asked if we could get the appliances and means of breakfast? Instead of having my eyes most ferociously dammed, I was mildly and respectfully, but certainly in a sailor-like manner, answered, ‘Yes to be sure, what would you like to have?’ Here the extent of my commission was run and I was obliged to return aft for further instructions. The result was, ‘The officers’ compliments and if it is convenient, they would be glad of the loan of cups, saucers &c, as they would rather not open their canteens till they get on shore.’ ‘You can have anything of the sort you like; only, as the steward has run from the ship, I shall be obliged to you if you will order your own servants to attend you.’ In the meanwhile, I ought to remark that we had left Ramsgate harbour about six, with a gentle, but fair breeze; and that breakfast was got ready soon after seven, with a voluntary assurance, on the part of Captain "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dung")]), _vm._v(" [the Master], that if he could in any way contribute to our comfort, we had only to let him know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The breakfast requires no description, unless I add that, instead of having newspapers to read, or politics to discuss at it, we made Captain "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dung")]), _vm._v(" the common theme. We began to suspect that he had been more drunk than insolent overnight and that probably he had taken as much provocation as liquor. We thought that the surgeon [Robinson] had gone rather far in calling a man out of bed to be reprimanded, who owed him no allegiance and that Growler [Otway] himself did not look perfectly "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("dignified, sitting with the tea "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("depot")]), _vm._v(" in his hand. This was the opinion of three out of five; so we resolved, especially as he had it more in his power to annoy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("us")]), _vm._v(" than we had it in ours to annoy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(", to agree to an amnesty; as it was evident that the man was not only sorry for what had occurred, but disposed to make the best amends in his power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The greater part of the regiment had been very wisely placed onboard small vessels, drawing little water; whereas ours was a magnificent brig, of nearly three hundred tons burthen and draught accordingly. We carried about fifty horses and soldiers in proportion: their numbers however, had nothing to do either with our accommodation or arrangements. In truth, the occasion resembled more the affair of a ferrying across than of a sea voyage; for we had not been long out of sight of the English coast before that of the Netherlands presented itself. I believe we first caught a sight of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dunkirk")]), _vm._v(", our destination being "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ostend")]), _vm._v(". The day was particularly fine, the water smooth and our progress, though not rapid, satisfactory and steady. I do not remember anyone being sick; and we dined upon "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("picnic,")]), _vm._v(" each having furnished himself with something, which was added to a general muster in the victualling department. The pleasures of the table were considerably interfered with by our approach towards the destined port. All of course, soon began to be anxiety and preparation for leaving a scene in which no long time had been spent; and as much bustle as old soldiers are capable of, or the superintendence of experienced officers will permit, was the order of the afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But we had reckoned without our captain in the first instance and were now about to be convinced of our error. On we went, in our fine, gallant vessel, commiserating the situation of our friends in the small craft, which had enough to do to keep up with us, till about 4 pm; when, within three or four hundred yards of the pier of Ostend harbour, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("headquarters")]), _vm._v(" of the dragoons, instead of being established in the Hotel of the Emperor [Hotel de l’Empereur], were deposited upon a sand bank. This came of our pride in chusing the largest and deepest lying ship, when we ought to have selected the smallest. This was the end of our ‘high notions’ as to accommodation. Upon the whole, there was a very pleasant prospect; a lee shore, night coming on, horses to be lost or injured, baggage thrown into the water, confusion and in the event of a blowing night, the probable loss of some of our own lives. It was not quite high water and the greatest of our hopes amounted to getting the ship afloat again and moving off to "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("sea: working her into Ostend was out of the question. Poor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dung")]), _vm._v(" began to find fault with those who had despatched so large a vessel on such an expedition: ‘They ought,’ he said, ‘to have known better than to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("suppose")]), _vm._v(" she could get into Ostend. For his own part, he would not come there again (provided he ever got back) for all the Agents of Transports in England.’ The higher the tide rose, we seemed only the better able to set at defiance every attempt at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("buoyancy")]), _vm._v("; and while all our energies were concentrated upon this object, a vessel, apparently about the dimensions of our own, (entangled most probably in a narrow channel which gave no choice of course to steer) came bearing down upon our broadside, with a huge anchor over her bow. This was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("truly")]), _vm._v(" formidable. For my own part, although at first provoked at the apparently wanton perseverance in a course that must inevitably run the ships foul, my anxiety was altered to consideration for the animals below, as it appeared to be a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("demonstration")]), _vm._v(" that the other one’s anchor would go through the side of our ship, like that of a green-house and do damage among the poor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("horses")]), _vm._v(". At all events, I am ashamed to say that at this moment, I derived considerable consolation from knowing that my own cattle [horses] were on the side opposite to the one from which the attack was to come. In the meantime, our consort approached so near, that the danger of being in the way of her gib boom became a consideration; when all immediate fears were removed by seeing her suddenly arrested by the same obstacle which had presented itself in our own way. She grounded close to us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tide began to ebb and all chance of floating till morning became hopeless. A boat was got out, and some of the officers went to the town to give notice of our situation and obtain assistance, the means more especially of removing the horses. While the preceding efforts were making in vain, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("little")]), _vm._v(" vessels ran past us and gained the harbour without difficulty, we of headquarters being half ashamed to shew ourselves, in the awkward situation into which our pomposity had gotten us. Our two stuck-fasts were in no long time left in possession of the whole visible German Ocean [North Sea] and our companions at length returned with intelligence that assistance would forthwith be forwarded. The only aid we did receive however, was a small boat, in which was an officer of the Transport Department, who kindly inquired (without coming nearer than was absolutely necessary) how we did. He returned to his dinner and we began to reconcile ourselves to that for which there appeared to be no remedy.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Night closed upon us, but without any alarming appearances as to the article of weather; our situation, therefore, though certainly dangerous, was by no means terrific. We concluded that the wisest thing we could do, was to take up our quarters in the fine large cabin and entertain one another as well as we could, under the circumstances. The conduct of Captain "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dung")]), _vm._v(" (for I have now forgotten, if ever indeed, I knew his proper name) was such as to have gained our entire confidence and we considered it useless to cherish alarm, where such a feeling could only have increased the unpleasantness of our situation. The real difficulty of the moment arose from our not having been provided with more "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("prog")]), _vm._v(" [food] than was necessary for one day’s consumption, calculating as we had every reason to do, (and as the event, with regard to our friends in the other ships, fully bore us out in) that we should have, ere this, been able to avail ourselves of the plentiful resources of fat Belgium. Here however, we suffered no sort of inconvenience; for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dung")]), _vm._v(", in the most considerate manner, informed us, that he had a joint or two of fresh meat and the remains of a stock of excellent claret, to all which we were welcome and for which he afterwards would accept of no consideration beyond the price of these articles had cost him. It is but justice to record, that one of our party having left his snuffbox on board in the hurry of disembarking, it was not only taken care of, but forwarded to him by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dung’s")]), _vm._v(" attentive exertions, when it must have been out of his way even to have ascertained where we were. The truth is that, though a coarse seaman in his aspect and manners, he was a gentleman in his feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Day broke and found us still immoveable, if not firm as the Eddystone, or the Bell Rock."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn50",
      "id": "ch1fn50"
    }
  }, [_vm._v("50")])]), _vm._v(" The tide, however, was again flowing and we were not without hope that we should be able to escape from the bank and take refuge in deeper water, farther out at sea, for not a sign of assistance had approached us during the night. Whether it was owing to a more dexterous application of our powers, or a more favourable concurrence of circumstances I forget, but we had not been very long engaged in the struggle till the vessel swung off, was put under sail and steered to [a] safer anchorage, where she had (while the weather continued moderate) at least the privilege of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("floating")]), _vm._v(". How our bedfellow got up in the morning I do not "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("distinctly remember; but I recollect that she did get away undamaged and that the wrecks which took place upon that coast, a few days afterwards, included neither of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("us")]), _vm._v(" in the unfortunate number.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our safety being thus so far provided for, notwithstanding an assurance from Captain "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dung")]), _vm._v(", that if the weather looked threatening before the means of disembarking came (trying the port with such a ship being preposterous), he would be obliged to take us back to England. We began to think we had the best of it, when compared with the regiment at large. It soon commenced raining most implacably and we knew that our friends on shore were exposed to a march in the open air, spoiling all their accoutrements and equipments, while we were enjoying first a good breakfast, then a pleasant lounge, afterwards no bad dinner and some excellent claret with unparalleled droll stories. We had no songs: we did not want them. Growler [Otway] was an original, of whom I had not seen much up to this period, but as he was in perfect good humour, he amused us considerably. The doctor, as they called him, did all he could to keep up the mirth. Of [James Castley], I have only to say here, that for a perfectly well dried piece of genuine and original wit, I never met with his equal. Of myself it becomes me to say nothing; but my part of the performance was spoken of for years afterwards: the Adjutant possessed great powers of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("laughter")]), _vm._v("; so that each man played his part and the rainy day was all but forgotten. It may be asked, what the troopers had for consolation, while we were so well off? I answer, excellent ship’s rations, consisting of beef, bread and rum and little or nothing to do but to enjoy one another’s company. Thus passed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monday")]), _vm._v(", without the slightest attempt to interfere with us from any point of the compass; and had we gone in search of the North Pole, it is my opinion that no one would have discovered it till we came back again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Feeling ourselves in comparative safety on Monday night, we turned in with more confidence than we had been able to muster the night before and slept, in all probability, a little sounder. With the following morning our hopes as to extrication were revived. The master of the vessel refused "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("point blank")]), _vm._v(" to venture near the harbour again: he had received sufficient warning and it was more than the safety of all on board was worth to make the experiment a second time; so, if no aid came from the shore, he must take us back, to be embarked onboard vessels whose draught of water did not exceed the depth over the sandbanks. To have withstood "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("this determination by any opposite one, on our part, would have been madness. However, in the course of the day, advice was received that a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("schuyt")]), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn51",
      "id": "ch1fn51"
    }
  }, [_vm._v("51")])]), _vm._v(" would be despatched to our relief, capable of removing the whole of us at once and towards evening she made her appearance, much to our satisfaction, notwithstanding the resignation we had manifested under the untoward nature of our circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the ‘craft’ in question came alongside, she appeared by no means too large to be accommodated between the masts of the headquarter ‘barge’; yet into these comparatively narrow limits were we all, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("horse and foot")]), _vm._v(", transferred with a precipitation that was apparently as unaccountable as uncalled for. The afternoon was fine and the sea smooth; but such was Captain "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dung’s")]), _vm._v(" uneasiness about his position, in the vicinity of the submarine [underwater] Netherlands, that, which one portion of the ship’s crew was hoisting "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("us")]), _vm._v(" out, another was heaving short the anchor and dropping the sails to be ready for a start; and no sooner were we all bundled into the schuyt, than away they went, as if expecting us to board them, sword in hand. We now found ourselves crowded enough above and our half hundred cattle [horses] still more so below, where there was this advantage arising out of their paved situation, that not one had room to fall, or to lift his foot against his neighbour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Little incidents like these, are not of themselves worth recollecting, still less perhaps of recording; but they show the realities of life in some of those situations which we strive to avoid, but when placed in, feel no hardship from. Thus, the party which could not find a ship large enough to contain them, but a short time previously, was now perfectly well satisfied with a space not much larger than that ship’s cabin. True, an hour or two was the probable extent of our prospect here; but necessity and not selection, was the cause of our resignation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whoever has been, not only at sea, but compelled to live in contracted space anywhere, must have observed how the accommodation, which was at first deemed insufficient and intolerable, expanded daily. For my own part, I had on many prior and have upon some subsequent occasions, been crammed, among numerous fellow travellers, into positions which "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("civil")]), _vm._v(" calculations would have materially enlarged, but which "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("military")]), _vm._v(" eyes, judgment and admeasurements considered with less apparent, but more "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("real accuracy. ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Man wants but little here below")]), _vm._v("’ and in the schuyt we did not ‘want that little long.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As was the case with other regiments and according to a well-known rule, when corps are about to proceed on active service, only a certain and that a small number of soldiers’ wives was permitted to accompany each troop. I believe ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sergeants’ ladies")]), _vm._v("’ were extra-numerical; and as all the Staff sergeants were embarked in our ship, I recollect that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("beau sexe")]), _vm._v(" mustered comparatively strong upon the deck of the schuyt. It was a large, flat-bottomed and unwieldy barge, of the Dutch fashion, carrying huge sails, one of which was called by a name that sounded like no very polite word in the English language and which, when pronounced with an order ‘to hoist’, tickled the imaginations and excited the titters of the ‘passengers’. It was thought so curious a coincidence, that the order given by the skipper was sometimes quoted, upon after occasions, with a very ludicrous effect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("transported")]), _vm._v(" as we now were, the cross-grained harbour of Ostend would not permit our approach to its interior and we had to leave our craft outside, while we ourselves got ashore in a small leaky boat and found the colonel waiting for his horses. By his kind directions, we gained a hotel and were soon furnished with a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Netherlandische")]), _vm._v(" repast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before commencing a new chapter, I beg to remark that I was surprised at finding all the old, smooth, counterfeit halfpence, which had many years before, been annihilated in England, in full and free circulation at Ostend and afterwards in other parts of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Belgique")]), _vm._v(": buttons without eyes and all manner of sorts of substitutes for the genuine small coin, or tinker’s money of any civilised state. So much and so iniquitously (no doubt) was the exchange against our country, that we were obliged to put up with sixteen francs for a pound note; while ten more afterwards barely amounted to par.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the course of the evening, intelligence came that the schuyt had entered the harbour; we all repaired to the beach, where, about ten o’clock, we accomplished the task of getting our baggage and horses onshore, a few of the latter notwithstanding the shallowness of water which had been so satisfactorily demonstrated, having had a swim for it: and thus terminated our April fool’s day."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#rch1fn52",
      "id": "ch1fn52"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn1",
      "id": "rch1fn1"
    }
  }, [_vm._v("1")]), _vm._v(".")]), _vm._v(" Hounslow Heath was regularly used for Military Reviews attended by the Royal family with easy access from Windsor.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn2",
      "id": "rch1fn2"
    }
  }, [_vm._v("2")]), _vm._v(".")]), _vm._v(" There were six approved different sword cuts in the exercise of cavalrymen.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn3",
      "id": "rch1fn3"
    }
  }, [_vm._v("3")]), _vm._v(".")]), _vm._v(" Doncaster racecourse is one of the oldest horse racing establishments in England, having races as early as the sixteenth century. It is famous for two major races, the Doncaster Cup and the St Leger Stakes.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn4",
      "id": "rch1fn4"
    }
  }, [_vm._v("4")]), _vm._v(".")]), _vm._v(" He served in the Peninsula from 1811 to 1814, mostly at General Hospital locations.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn5",
      "id": "rch1fn5"
    }
  }, [_vm._v("5")]), _vm._v(".")]), _vm._v(" The Honourable Frederick John Robinson was Vice President of the Board of Trade in 1815 and joint Paymaster of the Forces. His Corn Importation Bill successfully passed through Parliament in February 1815, a protectionist measure which imposed minimum prices on imported wheat and other grains, preventing them undercutting the price of home-produced grain. Robinson was granted a peerage in 1827, becoming Viscount Goderich. On the death of Canning in that August, King George IV asked him to form a government, but he was a failure, his premiership lasting only 144 days.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn6",
      "id": "rch1fn6"
    }
  }, [_vm._v("6")]), _vm._v(".")]), _vm._v(" The county town of Berkshire was Abingdon-on-Thames until 1867.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn7",
      "id": "rch1fn7"
    }
  }, [_vm._v("7")]), _vm._v(".")]), _vm._v(" He belonged to the 12th (or the Prince of Wales’) Regiment of Light Dragoons.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn8",
      "id": "rch1fn8"
    }
  }, [_vm._v("8")]), _vm._v(".")]), _vm._v(" On 25 March, the regiment was in the vicinity of Reading, four troops in Reading, two (Wallace and Webb’s Troops) at Maidenhead and two (Sandys and Andrew’s Troops) at Henley. The regiment numbered 502 rank & file and 441 horses.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn9",
      "id": "rch1fn9"
    }
  }, [_vm._v("9")]), _vm._v(".")]), _vm._v(" The Royal Regiment of Horse Guards.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn10",
      "id": "rch1fn10"
    }
  }, [_vm._v("10")]), _vm._v(".")]), _vm._v(" The principal inn was the Crown and Thistle at Abingdon-on-Thames.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn11",
      "id": "rch1fn11"
    }
  }, [_vm._v("11")]), _vm._v(".")]), _vm._v(" Sir Francis Burdett, a reformer, was found guilty of libelling the House of Commons in 1810 and troops were required to arrest him and take him to the Tower of London. When released in 1815 there was a great fear of a large demonstration which could potentially turn riotous, but Burdett chose to avoid the crowds and took a boat up the Thames and the crisis was averted. Lord Cochrane was a friend and supporter of Burdett, but Burdett kept him at arm’s length after Cochrane had proposed some form of military action in his defence in 1810. Cochrane was in King’s Bench, the prison for debtors, having been found guilty in 1814 of a major fraud on the Stock Exchange.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn12",
      "id": "rch1fn12"
    }
  }, [_vm._v("12")]), _vm._v(".")]), _vm._v(" Lieutenant Colonel the Honourable Frederick Ponsonby 12th Light Dragoons, was actually a colonel in the army.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn13",
      "id": "rch1fn13"
    }
  }, [_vm._v("13")]), _vm._v(".")]), _vm._v(" The Saturday was 18 March 1815. He seems to be one day out consistently in his dates.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn14",
      "id": "rch1fn14"
    }
  }, [_vm._v("14")]), _vm._v(".")]), _vm._v(" Hounslow village was the first halt on the great coaching road from London to Bath. It was also the site of a large cavalry barracks, constructed during the Napoleonic Wars. It is highly likely that the regiment quartered there.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn15",
      "id": "rch1fn15"
    }
  }, [_vm._v("15")]), _vm._v(".")]), _vm._v(" Major James Bridger commanded the regiment during its march to the coast.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn16",
      "id": "rch1fn16"
    }
  }, [_vm._v("16")]), _vm._v(".")]), _vm._v(" Lieutenant Albert Goldsmid 12th Light Dragoons.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn17",
      "id": "rch1fn17"
    }
  }, [_vm._v("17")]), _vm._v(".")]), _vm._v(" They walked in the grounds of the beautiful Georgian pile of Osterley House designed by Robert Adam, now a gem in the National Trust portfolio.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn18",
      "id": "rch1fn18"
    }
  }, [_vm._v("18")]), _vm._v(".")]), _vm._v(" To pay off outstanding debts and to order new uniforms.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn19",
      "id": "rch1fn19"
    }
  }, [_vm._v("19")]), _vm._v(".")]), _vm._v(" Captain William Cowper Coles 12th Light Dragoons.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn20",
      "id": "rch1fn20"
    }
  }, [_vm._v("20")]), _vm._v(".")]), _vm._v(" Dick being a shorthand version of Richard, Lieutenant Richard Fulton was the only officer named Richard in the regiment and he was of equal rank to Goldsmid.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn21",
      "id": "rch1fn21"
    }
  }, [_vm._v("21")]), _vm._v(".")]), _vm._v(" The regiment had been stationed at Dorchester before being ordered towards London. William Hay described Dorchester: ‘it was the most horrid, dull, stupid inland town I had ever known.’")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn22",
      "id": "rch1fn22"
    }
  }, [_vm._v("22")]), _vm._v(".")]), _vm._v(" A curricle was a light two-wheeled chaise large enough for a driver and only one other.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn23",
      "id": "rch1fn23"
    }
  }, [_vm._v("23")]), _vm._v(".")]), _vm._v(" Note by Smith – About eight in the morning, HRH was going from town.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn24",
      "id": "rch1fn24"
    }
  }, [_vm._v("24")]), _vm._v(".")]), _vm._v(" Edward Augustus Duke of Kent, was the fourth son of King George III. He was made a Field Marshal in 1805.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn25",
      "id": "rch1fn25"
    }
  }, [_vm._v("25")]), _vm._v(".")]), _vm._v(" Note by Smith – Though none of those we met could tell us the way to Bromley, the stage coachman and passengers exhorted us to bring "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Boney")]), _vm._v(" over as soon as we could catch him. There was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("something")]), _vm._v(" in the advice, of which no one at the time could tell the meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn26",
      "id": "rch1fn26"
    }
  }, [_vm._v("26")]), _vm._v(".")]), _vm._v(" It is impossible to be certain of this lady’s identity.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn27",
      "id": "rch1fn27"
    }
  }, [_vm._v("27")]), _vm._v(".")]), _vm._v(" A term used by John Milton, indicating young ladies with small delicate hands.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn28",
      "id": "rch1fn28"
    }
  }, [_vm._v("28")]), _vm._v(".")]), _vm._v(" The 120-gun HMS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Howe")]), _vm._v(" was launched at Chatham on 28 March 1815.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn29",
      "id": "rch1fn29"
    }
  }, [_vm._v("29")]), _vm._v(".")]), _vm._v(" There were two officers in the regiment with a surname beginning with H, Lieutenant William Heydon, who had been a lieutenant for ten years already and would not gain a captaincy for another ten years yet and Lieutenant William Hay. Hay was certainly not married, leaving Heydon as the likely candidate.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn30",
      "id": "rch1fn30"
    }
  }, [_vm._v("30")]), _vm._v(".")]), _vm._v(" The cavalry barracks built in 1794 were situated at Barton Mills just north of the city.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn31",
      "id": "rch1fn31"
    }
  }, [_vm._v("31")]), _vm._v(".")]), _vm._v(" The regiment was inspected at Canterbury, by Major General Sir Dennis Pack.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn32",
      "id": "rch1fn32"
    }
  }, [_vm._v("32")]), _vm._v(".")]), _vm._v(" On embarkation, the regiment left 16 sergeants, 5 trumpeters, 113 men and 46 horses behind to form the depot.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn33",
      "id": "rch1fn33"
    }
  }, [_vm._v("33")]), _vm._v(".")]), _vm._v(" Note by Smith – The two other troops (making ten) were reformed, and the officers in the old "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("break")]), _vm._v(", were re-instated.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn34",
      "id": "rch1fn34"
    }
  }, [_vm._v("34")]), _vm._v(".")]), _vm._v(" Note by Smith – Untrooping may be compared to shuffling a pack of cards for a new deal. Every man is thrown into the confused mass, whence he is afterwards taken into regulated hands.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn35",
      "id": "rch1fn35"
    }
  }, [_vm._v("35")]), _vm._v(".")]), _vm._v(" Note by Smith – There is a distinction between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("horse")]), _vm._v(", or cavalry, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dragoons")]), _vm._v(", which may as well be pointed out, though existing rather in words and deeds. Dragoons are troops capable of acting either "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("on foot or horseback")]), _vm._v(", whereas "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("horse")]), _vm._v(" act only when mounted. Excepting the Household Brigade of Life Guards and Oxford Blues, all the mounted soldiers of the British army are styled dragoons, dragoon guards, heavy and light dragoons. These last are all dressed in blue, the former in red; and though "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hussars")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lancers")]), _vm._v(" are now to be found in our army, they are officially known at the War Office only as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dragoons")]), _vm._v(", according to their number, 7th, 8th, 9th &c.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn36",
      "id": "rch1fn36"
    }
  }, [_vm._v("36")]), _vm._v(".")]), _vm._v(" Surgeon Benjamin Robinson had joined the 12th Light Dragoons in October 1803 and served with them in the Peninsula from June 1811 until April 1814.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn37",
      "id": "rch1fn37"
    }
  }, [_vm._v("37")]), _vm._v(".")]), _vm._v(" Assistant Surgeon Patrick Egan was listed on detached service and was not present at Waterloo. Egan had originally been appointed Assistant Surgeon to the 23rd Light Dragoons in April 1809, serving with them at Talavera, before transferring to the 12th Light Dragoons in October 1812 and served in the Peninsula with them from January 1813 until April 1814.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn38",
      "id": "rch1fn38"
    }
  }, [_vm._v("38")]), _vm._v(".")]), _vm._v(" About £400 in modern terms.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn39",
      "id": "rch1fn39"
    }
  }, [_vm._v("39")]), _vm._v(".")]), _vm._v(" The old soldier must have been an ex-23rd Light Dragoons man.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn40",
      "id": "rch1fn40"
    }
  }, [_vm._v("40")]), _vm._v(".")]), _vm._v(" Note by Smith: The valise of the horseman is strapped behind his saddle; the infantry soldier carries his knapsack upon his own back. Each contains nearly the same articles; such as shirts, stockings, spare shoes, forage cap, &c; but for horses there are a few more requisites; viz currycombs, hand brushes &c. Long after I joined the [12th], a wisp of straw was the only thing employed in grooming; but it was afterwards judged proper to introduce the manufactured articles specified. The horse of a light dragoon is expected to be master of twenty-two stone, jockey weight.")]), _vm._v(" "), _c('table', {
    staticClass: "tabn"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tdn1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Estimate")])]), _vm._v(" "), _c('td', {
    staticClass: "tdn2a",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stone (Jockey weight of 14 lb) lbs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdn1"
  }, [_vm._v("1st A light rider")]), _vm._v(" "), _c('td', {
    staticClass: "tdn2"
  }, [_vm._v("12")]), _vm._v(" "), _c('td', {
    staticClass: "tdn3"
  }, [_vm._v("168")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdn1"
  }, [_vm._v("2nd Clothing &c personally worn")]), _vm._v(" "), _c('td', {
    staticClass: "tdn23"
  }, [_vm._v("1 (at least)")]), _vm._v(" "), _c('td', {
    staticClass: "tdn3"
  }, [_vm._v("14")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdn1"
  }, [_vm._v("3rd 3 days’ rations for himself and horse")]), _vm._v(" "), _c('td', {
    staticClass: "tdn23a"
  }, [_vm._v("5 (and upwards)")]), _vm._v(" "), _c('td', {
    staticClass: "tdn3"
  }, [_vm._v("70")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdn1"
  }, [_vm._v("4th Arms, accoutrements, 60 rounds of ammunition, Spare clothing, necessaries, with allowance for personal weight, over 12 stone & c.")]), _vm._v(" "), _c('td', {
    staticClass: "tdn22"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', {
    staticClass: "tdn32"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("56")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tdn1"
  }), _vm._v(" "), _c('td', {
    staticClass: "tdn2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("22")])]), _vm._v(" "), _c('td', {
    staticClass: "tdn3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("308")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("It is to be observed, that this is a low estimate for what actually occurs on service, upon many occasions of emergency. The corn is carried in a sack, balanced behind the saddle; the hay or straw is packed into nets and slung across the saddle "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bow")]), _vm._v(". Upon field days in France the men were ordered to appear always in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("light")]), _vm._v(" marching order; which meant without rations and forage (as in England) but they used to stuff their valises with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hay")]), _vm._v(", till the trick was found out, and necessaries were "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("necessarily")]), _vm._v(" packed up on future occasions.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn41",
      "id": "rch1fn41"
    }
  }, [_vm._v("41")]), _vm._v(".")]), _vm._v(" James Castley was originally appointed as Veterinary Surgeon to the 15th Light Dragoons in June 1807, but transferred to the 12th Light Dragoons in August 1809. He had seen extensive service in the Peninsula.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn42",
      "id": "rch1fn42"
    }
  }, [_vm._v("42")]), _vm._v(".")]), _vm._v(" Paymaster William Loftus Otway 12th Light Dragoons, also called throughout ‘Growler’.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn43",
      "id": "rch1fn43"
    }
  }, [_vm._v("43")]), _vm._v(".")]), _vm._v(" The Adjutant was Lieutenant John Griffiths.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn44",
      "id": "rch1fn44"
    }
  }, [_vm._v("44")]), _vm._v(".")]), _vm._v(" Larboard was used for the port or left side of the ship until the 1860s.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn45",
      "id": "rch1fn45"
    }
  }, [_vm._v("45")]), _vm._v(".")]), _vm._v(" Greek – The masses.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn46",
      "id": "rch1fn46"
    }
  }, [_vm._v("46")]), _vm._v(".")]), _vm._v(" An Irish king 1002 to 1014.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn47",
      "id": "rch1fn47"
    }
  }, [_vm._v("47")]), _vm._v(".")]), _vm._v(" A tea urn.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn48",
      "id": "rch1fn48"
    }
  }, [_vm._v("48")]), _vm._v(".")]), _vm._v(" Note by Smith – And we anticipated the disagreeable duty of having to keep an eye upon the master; a duty of which, for my own part, I had some experience.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn49",
      "id": "rch1fn49"
    }
  }, [_vm._v("49")]), _vm._v(".")]), _vm._v(" Note by Smith – At this moment I do not believe the man knew that one of us had left the cabin; in fact, we came upon deck when he was quite unprepared for our appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn50",
      "id": "rch1fn50"
    }
  }, [_vm._v("50")]), _vm._v(".")]), _vm._v(" The third Eddystone Lighthouse off Rame Head in Cornwall was constructed in 1759 and Bell Rock Lighthouse off the Firth of Tay was completed in 1811.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn51",
      "id": "rch1fn51"
    }
  }, [_vm._v("51")]), _vm._v(".")]), _vm._v(" A barge-like flat-bottomed boat used extensively on canals and in coastal trade.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('span', {
    staticClass: "note1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1fn52",
      "id": "rch1fn52"
    }
  }, [_vm._v("52")]), _vm._v(".")]), _vm._v(" They disembarked on the evening of Monday 3 April.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f58bd16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chapter01.vue
// module id = 81
// module chunks = 0